import { createFileRoute } from '@tanstack/react-router'
import { MyNetworkPage } from '@/pages/MyNetworkPage'
import { requireAuth } from '@/utils/routeGuards.ts'

const MyNetworkRoute = () => {
  return <MyNetworkPage />
}

export const Route = createFileRoute('/my-network')({
  beforeLoad: requireAuth,
  component: MyNetworkRoute,
})
